// extracted by mini-css-extract-plugin
module.exports = {"close":"navstyles_close__3vP3a","grey_text":"navstyles_grey_text__2N3s1","title_row":"navstyles_title_row__Ne3qU"};